import styled from "styled-components";

export const UserStatistics = styled.div`
  @media (max-width: 992px) {
    p {
      font-size: .95rem; 
    }
  }
`;
